'use client';

import { useEffect } from 'react';
import useAuth from '@/hooks/useAuth';
import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { fetchPrices, selectPayment, setHadWeeklyDiscount } from '@/store/slices/paymentSlice';

export default function usePaddlePricing() {
  const dispatch = useAppDispatch();
  const { user } = useAuth();
  const {
    prices, // Formatted prices object
    rawMonthlyPrices,
    rawYearlyPrices,
    rawWeeklyPrices,
    isLoadingPrices,
    pricesError,
    hadFreeTrial,
    hadWeeklyDiscount,
  } = useAppSelector(selectPayment);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchPrices(user?.customerId)).unwrap();
      } catch (error) {
        if ((error as { name?: string })?.name === 'ConditionError') return;
        console.error('Error fetching prices:', error);
      }
    };

    if (!user) return;

    if (!prices) {
      fetchData();
    }

    dispatch(setHadWeeklyDiscount(!!user.hadWeeklyDiscount));
  }, [dispatch, user, user?.customerId, prices, user?.hadWeeklyDiscount]);

  return {
    prices,
    monthlyPrices: rawMonthlyPrices ?? [],
    yearlyPrices: rawYearlyPrices ?? [],
    weeklyPrices: rawWeeklyPrices ?? [],
    isLoadingPrices,
    pricesError,
    hadFreeTrial,
    hadWeeklyDiscount,
  };
}
